import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/profile/actionTypes';

import { loadCustomerStripe } from './utils';

export default function* listenSetProfile() {
  yield takeEvery(actionTypes.SET_PROFILE, loadCustomerStripe);
}
